// services/kundliService.js
import axios from "axios";

const baseURL = process.env.NODE_ENV === 'production' ? '' : (process.env.REACT_APP_API_BASE_URL || `http://${window.location.hostname}:5001`);

export const fetchKundliFromBirthData = async ({ date, time, lat, lon }) => {
  try {
    const response = await axios.post(
      `${baseURL}/api/ephemeris`,
      {
        date,
        time,
        lat,
        lon,
      }
    );

    console.log("%c🔮 Kundli API Sync Complete", "color: #b08d57; font-size: 12px; font-weight: bold; background: #1a1a24; padding: 4px; border-radius: 4px;");
    return response.data;
  } catch (error) {
    console.error("❌ Error in fetchKundliFromBirthData:", error);
    throw new Error("Failed to fetch kundli");
  }
};

export const fetchCurrentEphemeris = async (lat = 28.6358, lon = 77.2245) => {
  try {
    const response = await axios.get(`${baseURL}/api/ephemeris/current`, {
      params: { lat, lon }
    });
    return response.data;
  } catch (error) {
    console.error("❌ Error in fetchCurrentEphemeris:", error);
    throw new Error("Failed to fetch current ephemeris");
  }
};
